var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/post"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.832 20.5H4.796c-.716 0-1.296-.725-1.296-1.619V8.761C3.5 5.857 5.386 3.5 7.713 3.5h10.705M9.102 15.12v2.653m-2.318-2.737h4.637M7.17 12.81h3.863m7.92-9.31c-1.828 0-3.477 2.132-3.477 5.262V20.5h3.477c.854 0 1.546-.725 1.546-1.619V5.119c0-.894-.692-1.619-1.546-1.619ZM6.977 7.548h4.637c.64 0 1.159.543 1.159 1.214 0 .67-.52 1.214-1.16 1.214H6.978c-.64 0-1.159-.543-1.159-1.214 0-.67.52-1.214 1.16-1.214Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.98a2d8b4fa9da132409cb69552a47b3b.svg";
export { ForwardRef as ReactComponent };